import { useSearchParams } from "react-router-dom";
import { PublicNav, PublicFooter } from "../../components/public/PublicNav";
import { NewsletterSignup } from "../../components/public/NewsletterSignup";
import { useSeo } from "../../hooks/useSeo";
import { CheckCircle2, MailX, AlertTriangle } from "lucide-react";

const STATUS = {
  confirme: { icon: CheckCircle2, title: "Inscription confirmée", text: "Merci ! Votre première newsletter arrive lundi à 8h." },
  desinscrit: { icon: MailX, title: "Vous êtes désinscrit(e)", text: "Vous ne recevrez plus la newsletter. Vous pouvez vous réinscrire à tout moment ci-dessous." },
  invalide: { icon: AlertTriangle, title: "Lien invalide ou expiré", text: "Ce lien n'est plus valable. Vous pouvez refaire une demande ci-dessous." },
};

export const PublicNewsletter = () => {
  useSeo({
    title: "Newsletter — Les sorties de la semaine | Rouge Première",
    description: "Chaque lundi matin : les sorties films et séries de la semaine et les derniers articles de la rédaction Rouge Première.",
  });
  const [params] = useSearchParams();
  const st = STATUS[params.get("statut")];

  return (
    <div>
      <PublicNav />
      <main className="max-w-2xl mx-auto px-5 py-20" data-testid="newsletter-page">
        {st && (
          <div data-testid={`newsletter-status-${params.get("statut")}`} className="mb-10 border border-[var(--line)] bg-[var(--bg-cream)] rounded-md p-5 flex gap-3">
            <st.icon className="h-5 w-5 text-[var(--red)] shrink-0 mt-0.5" />
            <div>
              <div className="font-display text-xl">{st.title}</div>
              <p className="text-sm text-neutral-600 mt-1">{st.text}</p>
            </div>
          </div>
        )}
        <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--red)] font-medium">Newsletter</div>
        <h1 className="font-display text-4xl sm:text-5xl mt-2">Les sorties de la semaine, chaque lundi.</h1>
        <p className="text-neutral-600 mt-4 leading-relaxed">
          Les films en salle, les séries sur vos plateformes et les derniers articles de la rédaction —
          un résumé court, avec les liens pour en savoir plus.
        </p>
        <div className="mt-8"><NewsletterSignup id="newsletter-page" /></div>
      </main>
      <PublicFooter />
    </div>
  );
};
